<!-- <div class="m-subheader ">
	<div class="d-flex align-items-center">
		<div class="mr-auto">
			<h3 class="m-subheader__title m-subheader__title--separator">
				Rozgar Mela
			</h3>
			<ul class="m-subheader__breadcrumbs m-nav m-nav--inline">
				<li class="m-nav__item m-nav__item--home">
					<a href="javascript:;" class="m-nav__link m-nav__link--icon">
						<i class="m-nav__link-icon la la-home"></i>
					</a>
				</li>
			</ul>
		</div>
	</div>
</div> -->

<div class="m-content" style="margin-right: 1%" *ngIf="!isChangeProfile">
	<div class="m-portlet m-portlet--tab" style="padding: 1em">
		<div class="m-portlet__body1 form-group m-form__group row">
			<div class="col-6">
				<h4 class="m-portlet__head-text">
					Candidate Certificate
					<!-- Rozgar Mela - ID1232 - Created by NSDC SPOC -->
				</h4>
			</div>
			<div class="col-xl-6" style="text-align: right">
				<div class="m-demo__preview m-demo__preview--btn">
					<!-- <button *ngIf="details.status === 'On-Going' || details.status === 'To be Conducted'" type="button" class="btn btn-secondary btn-sm header-btn" (click)= "navigateTOCreateJobFairSpoc()">Create Job Fair SPOC </button> -->
					<button type="button" class="btn btn-secondary btn-sm header-btn" (click)="location.back()">
						Back
					</button>
				</div>
			</div>
		</div>
		<hr />
		<!-- <div class="table-component">
<app-table  [headers]="headers"  (filter)="onFilter($event)"  [pagination]="pagination" [appliedFilter]="defaultFilters"
 (pageNumberChange)="selectedPage($event)" (recordsPerPageChange)="onRecordsPerPage($event)" ></app-table>
</div> -->
		<div class="m-portlet__body">
			<div *ngIf="currentUserData.role === 'Training Centre'" class="row"
				style="margin-top: 19px; margin-left: 16px">
				<div class="col-md-2">
					<label>
						<b>Batch Id
							<span style="color: red; font-weight: bold">*</span></b>
					</label>
					<select (change)="batchIdChanged()" class="form-control selectcolor" id="m_select2_1" name="param"
						[(ngModel)]="modelObj.batchId">
						<option value="" disabled selected>All</option>
						<option *ngFor="let batchId of batchIdDropDown" [ngValue]="batchId.ids">
							{{ showBatchId(batchId) }}
						</option>
					</select>
				</div>
				<div class="col-md-2">
					<label>
						<b>Batch Type
							<span style="color: red; font-weight: bold">*</span>
						</b>
					</label>
					<select (change)="getCandidateDropDown()" class="form-control selectcolor" id="m_select2_1"
						name="param" [(ngModel)]="modelObj.batchType">
						<option value="" disabled selected>Select</option>
						<option *ngFor="let type of batchTypeDropDown" [ngValue]="type">
							{{ type }}
						</option>
					</select>
				</div>
				<div class="col-md-2">
					<label>
						<b>Candidate Id</b>
					</label>
					<select class="form-control selectcolor" id="m_select2_1" name="param" [(ngModel)]="modelObj.canId">
						<option value="" disabled selected>All</option>
						<option *ngFor="let canId of candidateIdDropDown" [ngValue]="canId.ids">
							{{ canId.ids }}
						</option>
					</select>
				</div>
				<div class="col-md-6">
					<label> <br /> </label>
					<div>
						<button [disabled]="!modelObj.batchId" class="btn btn-primary" (click)="applyFilter()">
							Search</button>&nbsp;&nbsp;&nbsp;
						<button class="btn btn-secondary m-btn reset-btn" (click)="reset()">
							Reset
						</button>
						&nbsp;&nbsp;&nbsp;
						<ng-container *ngIf="candidateData && candidateData?.length">
							<button class="btn btn-primary pull-right" *ngIf="
									batchDetailsWithBulkInfo &&
									batchDetailsWithBulkInfo.bAssessmentStatus ===
										'ASSESSMENT DONE' &&
									batchDetailsWithBulkInfo &&
										batchDetailsWithBulkInfo.bulkZipURLDetails
								" (click)="downloadBulkCertificates()">
								Download Marksheets & Certificates
							</button>
							<!-- <button *ngIf="showBulkSkillCardButton && batchDetailsWithBulkInfo"
								class="btn btn-primary pull-right" (click)="downloadBulkSkillCard()">
								Bulk Download Skill Card
							</button> -->

							<button class="btn btn-primary pull-right mt-2" *ngIf="(batchData.schemeBasicDetails && batchData.schemeBasicDetails.niaRequired && batchData.schemeBasicDetails.niaRequired === true) &&
							(batchData?.type === 'pmkvy' ||
							batchData?.type === 'msde') &&
							(batchData?.schemeName === 'PMKVY-3.0-CSCM' ||
							batchData?.schemeName === 'MoHUA - Ministry of Housing and Urban Affairs')
						" (click)="downloadBulkInsuranceCard()">
								Download Bulk insuranceCard Card
							</button>
						</ng-container>
					</div>
				</div>
				<br />
				<br />
			</div>
			<div *ngIf="currentUserData.role === 'Training Partner'" class="row"
				style="margin-top: 19px; margin-left: 16px">
				<div class="col-md-2">
					<label>
						<b>TC Id
							<span style="color: red; font-weight: bold">*</span></b>
					</label>
					<select (change)="getBatchIdDropDown($event)" class="form-control selectcolor" id="m_select2_1"
						name="param" [(ngModel)]="modelObj.tcId">
						<option value="" disabled selected>Select</option>
						<option *ngFor="let tcId of tcIdsDropDownData" [ngValue]="tcId.ids">
							{{ tcId.ids }}
						</option>
					</select>
				</div>
				<div class="col-md-2">
					<label>
						<b>Batch Id
							<span style="color: red; font-weight: bold">*</span></b>
					</label>
					<select (change)="batchIdChanged()" class="form-control selectcolor" id="m_select2_1" name="param"
						[(ngModel)]="modelObj.batchId">
						<option value="" disabled selected>Select</option>
						<option *ngFor="let batchId of batchIdDropDown" [ngValue]="batchId.ids">
							{{ batchId.ids }}
						</option>
					</select>
				</div>
				<div class="col-md-2">
					<label>
						<b>Batch Type
							<span style="color: red; font-weight: bold">*</span>
						</b>
					</label>
					<select (change)="getCandidateDropDown()" class="form-control selectcolor" id="m_select2_1"
						name="param" [(ngModel)]="modelObj.batchType">
						<option value="" disabled selected>Select</option>
						<option *ngFor="let type of batchTypeDropDown" [ngValue]="type">
							{{ type }}
						</option>
					</select>
				</div>

				<div class="col-md-2">
					<label>
						<b>Candidate Id</b>
					</label>
					<select class="form-control selectcolor" id="m_select2_1" name="param" [(ngModel)]="modelObj.canId">
						<option value="" disabled selected>All</option>
						<option *ngFor="let canId of candidateIdDropDown" [ngValue]="canId.ids">
							{{ canId.ids }}
						</option>
					</select>
				</div>
				<div class="col-md-6">
					<label> <br /> </label>
					<div *ngIf="currentUserData.role === 'Training Centre'">
						<button [disabled]="!modelObj.batchId" class="btn btn-primary" (click)="applyFilter()">
							Search</button>&nbsp;&nbsp;&nbsp;
						<button class="btn btn-secondary m-btn reset-btn" (click)="reset()">
							Reset
						</button>
					</div>
					<div *ngIf="currentUserData.role === 'Training Partner'">
						<button [disabled]="!valid" class="btn btn-primary" (click)="applyFilter()">
							Search</button>&nbsp;&nbsp;&nbsp;
						<button class="btn btn-secondary m-btn reset-btn" (click)="reset()">
							Reset</button>&nbsp;&nbsp;&nbsp;

						<ng-container *ngIf="candidateData && candidateData?.length">
							<button class="btn btn-primary pull-right" *ngIf="
								batchDetailsWithBulkInfo &&
								batchDetailsWithBulkInfo.bAssessmentStatus ===
									'ASSESSMENT DONE' &&
								batchDetailsWithBulkInfo &&
									batchDetailsWithBulkInfo.bulkZipURLDetails && (assessmentStatus != 'Self' && assessmentStatus != 'Third Party')
							" (click)="downloadBulkCertificates()">
								Download Marksheets & Certificates
							</button>
							<!-- <button *ngIf="showBulkSkillCardButton && batchDetailsWithBulkInfo"
								class="btn btn-primary pull-right" (click)="downloadBulkSkillCard()">
								Bulk Download Skill Card
							</button> -->
							<button class="btn btn-primary pull-right mt-2" *ngIf="(batchData.schemeBasicDetails && batchData.schemeBasicDetails.niaRequired && batchData.schemeBasicDetails.niaRequired === true) &&
							(batchData?.type === 'pmkvy' ||
							batchData?.type === 'msde') &&
							(batchData?.schemeName === 'PMKVY-3.0-CSCM' ||
							batchData?.schemeName === 'MoHUA - Ministry of Housing and Urban Affairs')
						" (click)="downloadBulkInsuranceCard()">
								Download Bulk insuranceCard Card
							</button>
						</ng-container>
						<ng-container *ngIf="assessmentStatus == 'Self' || assessmentStatus == 'Third Party' ">
							<button class="btn btn-primary pull-right"
								*ngIf="feebaseBatchData && !feebaseBatchData.bulkZipURLDetails"
								(click)="selfBatchBulkCertificateDownload()">
								Generate Bulk Certificates
							</button>
							<button class="btn btn-primary pull-right"
								*ngIf="feebaseBatchData && feebaseBatchData.bulkZipURLDetails"
								(click)="downloadBulkSelfCertificates()">
								Download Bulk Certificates
							</button>
						</ng-container>
					</div>
				</div>

				<br />
				<br />
			</div>
			<br />
			<br />
			<!--begin: Search Form -->
			<div>
				<ng-container *ngIf="candidateData && candidateData.length > 0">
					<ng-container *ngIf="batchMetaData && batchMetaData.type === 'pmkvy'">
						<h4>
							Batch Type: <b>{{batchMetaData.batchType}}</b>
						</h4>
					</ng-container>
				</ng-container>

				<!--begin: candidate login Search Form -->
				<div>
					<div class="form-group m-form__group row">
						<table class="notranslate table table-striped m-table">
							<thead class="table-head-style">
								<tr>
									<th style="width: 10%">Sr. No.</th>
									<th>Candidate ID</th>
									<th>Candidate Name</th>
									<!-- <th>Batch ID</th> -->
									<th>Batch Name</th>
									<th>Job Roles</th>
									<th>Attendance</th>
									<th>Result</th>
									<!-- <th>Marksheet</th> -->
									<th>Certificate</th>
									<th *ngIf="(batchData?.schemeBasicDetails && batchData?.schemeBasicDetails?.niaRequired && batchData?.schemeBasicDetails?.niaRequired === true) && (batchData?.type === 'pmkvy' ||
									batchData?.type === 'msde') &&
									(batchData?.schemeName === 'PMKVY-3.0-CSCM' ||
									batchData?.schemeName === 'MoHUA - Ministry of Housing and Urban Affairs')">Insurance Card</th>
									<!-- <th>Assessment Certificate</th> -->
									<!-- <th>Action</th> -->
								</tr>
							</thead>
							<tbody>
								<tr *ngFor="
										let candidate of candidateData;
										let i = index
									">
									<td>{{ i + 1 }}</td>
									<td>
										{{ getCandidateUserName(candidate) }}
									</td>
									<td>{{ getCandidateName(candidate) }}</td>
									<!-- <td>{{candidate.batchId?candidate.batchId: 'N/A'}}</td> -->
									<td>
										{{
										candidate.batchName
										? candidate.batchName
										: "N/A"
										}}
									</td>
									<td>{{ getjRole(candidate.jobRoles) }}</td>
									<td>{{ getAttendance(candidate) }}</td>
									<td>{{ getResult(candidate) }}</td>
									<!-- <td *ngFor="
											let marksheet of candidate.jobRoles
										">
										<div style="
												color: #0092d8;
												cursor: pointer;
											" (click)="
												downloadMarksheet(marksheet)
											">
											Download
										</div>
									</td> -->
									<!-- <td>
										<span *ngIf="candidate.jobRoles[0] && candidate.jobRoles[0].markSheetDetails && 
										candidate.jobRoles[0].markSheetDetails.markSheetURLDetails && 
										candidate.jobRoles[0].markSheetDetails.markSheetURLDetails.key;else elseBlock">
											<div style="color: #0092d8;cursor: pointer;"
												(click)="downloadMarksheet(candidate.jobRoles[0])">
												Download
											</div>
										</span>
										<ng-template #elseBlock>N/A</ng-template>
									</td> -->
									<td>
										<div *ngIf="assessmentStatus != 'Self' && assessmentStatus != 'Third Party' ">
											<div *ngFor="let marksheet of candidate.jobRoles">
												<div style="
														color: #0092d8;
														cursor: pointer;
													" (click)="
														downloadCert(marksheet)
													">
													Download
												</div>
											</div>
										</div>

										<div *ngIf="assessmentStatus == 'Self' || assessmentStatus == 'Third Party' ">
											<div style="
													color: #0092d8;
													cursor: pointer;
												" (click)="
													downloadAssessmentCert(candidate)
												">
												Generate Certificate
											</div>
										</div>


									</td>
									<td *ngIf="(batchData?.type === 'pmkvy' ||
									batchData?.type === 'msde') &&
									(batchData?.schemeName === 'PMKVY-3.0-CSCM' ||
									batchData?.schemeName === 'MoHUA - Ministry of Housing and Urban Affairs')">
										<span *ngIf="candidate.insuranceCardUrl && candidate.insuranceCardUrl !== '' && candidate?.jobRoles[0]
										.attendanceStatus === true">
											<div style="color: #0092d8;cursor: pointer;"
												(click)="downloadInsuranceCard(candidate.insuranceCardUrl)">
												Download
											</div>
										</span>

										<span *ngIf="(batchData.schemeBasicDetails && batchData.schemeBasicDetails.niaRequired && batchData.schemeBasicDetails.niaRequired === true) && !candidate.insuranceCardUrl || candidate.insuranceCardUrl === null && candidate?.jobRoles[0]
										.attendanceStatus === true">
											<div style="color: #0092d8;cursor: pointer;"
												(click)="GenerateInsuranceCard(candidate)">
												Download
											</div>
										</span>
									</td>
									<!-- <td>
										<div style="
												color: #0092d8;
												cursor: pointer;
											" (click)="
												downloadAssessmentCert(candidate)
											">
											Generate Certificate
										</div>
									</td> -->
									<!-- <td>
										<div *ngIf = "assessmentStatus != 'Self'"> 
											<div *ngFor="
											let marksheet of candidate.jobRoles
										">
										<div style="
										color: #0092d8;
										cursor: pointer;
									" (click)="downloadCert(marksheet)">
									Download
								</div>
										</div>
										</div>

										<div *ngIf = "assessmentStatus == 'Self' ">
											<div style="
											color: #0092d8;
											cursor: pointer;
											" (click)="downloadCert(candidate)">
												Generate Certificate
											</div>
											
										</div>
										
									</td> -->

									<!-- <td>
										<div style="color: #0092d8;cursor: pointer;" (click) = "dowloadassesmentCert(candidate)">
											Download
										</div>
									</td> -->

									<!-- <td *ngFor="let data of candidate.jobRoles">{{data.jobName}}</td> -->

									<!-- <td data-field="Actions" class="m-datatable__cell">
										<span style="
												overflow: visible;
												width: 100px;
											">
											<div class="dropdown">
												<a href="#"
													class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
													data-toggle="dropdown">
													<i class="la la-ellipsis-h"></i>
												</a>
												<div *ngIf="batchDetailsWithBulkInfo?.schemeBasicDetails?.subSchemeName?.name != 'State Scheme- Odisha (WSC-RPL)' && showBulkSkillCardButton"
													(click)="
														generateSkillCard(
															candidate
														)
													" class="dropdown-menu dropdown-menu-right">
													<a class="dropdown-item">
														Generate Skill Card
													</a>
												</div>
											</div>
										</span>
									</td> -->
								</tr>
								<!-- *ngIf="!boData"  -->
								<tr *ngIf="candidateData.length === 0" style="color: grey; font-size: 17px">
									<td colspan="8">
										<p style="text-align: center">
											No Data Found
										</p>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<!--begin: tp/tc/ssc login Search Form -->
				<div *ngIf="length > 9">
					<app-pagination [count]="length" [defaultRecordsPerPage]="itemsPerPage"
						(pageNumber)="assignPageNo($event)" (recordsPerPage)="assignRecordsPerPage($event)">
					</app-pagination>
				</div>
				<!-- <div *ngIf="length > 9">
			<app-pagination [count]=length (pageNumber)="assignPageNo($event)" (recordsPerPage)="assignRecordsPerPage($event)"></app-pagination>
		</div> -->
			</div>
		</div>
	</div>
</div>

<!-- Changes to update candidate profile photo -->
<div class="m-content" style="margin-right: 1%" *ngIf="isChangeProfile">
	<div class="m-portlet m-portlet--tab" style="padding: 1em">
		<div class="m-portlet__body1 form-group m-form__group row">
			<div class="col-6">
				<h4 class="m-portlet__head-text">
					Update Candidate Profile Photo
				</h4>
			</div>
			<div class="col-xl-6" style="text-align: right">
				<div class="m-demo__preview m-demo__preview--btn">
					<button type="button" class="btn btn-secondary btn-sm header-btn" (click)="location.back()">
						Back
					</button>
				</div>
			</div>
		</div>
		<hr />
		<div class="m-portlet__body">
			<div *ngIf="currentUser?.role === 'Training Centre'" class="row"
				style="margin-top: 19px; margin-left: 16px">
				<div class="col-md-2">
					<label>
						<b>Batch Id
							<span style="color: red; font-weight: bold">*</span></b>
					</label>
					<select (change)="batchIdChanged()" class="form-control selectcolor" id="m_select2_1" name="param"
						[(ngModel)]="modelObj.batchId">
						<option value="" disabled selected>All</option>
						<option *ngFor="let batchId of batchIdDropDown" [ngValue]="batchId.ids">
							{{ showBatchId(batchId) }}
						</option>
					</select>
				</div>
				<div class="col-md-2">
					<label>
						<b>Batch Type
							<span style="color: red; font-weight: bold">*</span>
						</b>
					</label>
					<select (change)="getCandidateDropDown()" class="form-control selectcolor" id="m_select2_1"
						name="param" [(ngModel)]="modelObj.batchType">
						<option value="" disabled selected>Select</option>
						<option *ngFor="let type of batchTypeDropDown" [ngValue]="type">
							{{ type }}
						</option>
					</select>
				</div>
				<div class="col-md-2">
					<label>
						<b>Candidate Id</b>
					</label>
					<select class="form-control selectcolor" id="m_select2_1" name="param" [(ngModel)]="modelObj.canId">
						<option value="" disabled selected>All</option>
						<option *ngFor="let canId of candidateIdDropDown" [ngValue]="canId.ids">
							{{ canId.ids }}
						</option>
					</select>
				</div>
				<div class="col-md-6">
					<label> <br /> </label>
					<div>
						<button [disabled]="!modelObj.batchId" class="btn btn-primary" (click)="applyFilter()">
							Search</button>&nbsp;&nbsp;&nbsp;
						<button class="btn btn-secondary m-btn reset-btn" (click)="reset()">
							Reset
						</button>
					</div>
				</div>
			</div>
			<div *ngIf="currentUser?.role === 'Training Partner'" class="row"
				style="margin-top: 19px; margin-left: 16px">
				<div class="col-md-2">
					<label>
						<b>TC Id
							<span style="color: red; font-weight: bold">*</span></b>
					</label>
					<select (change)="getBatchIdDropDown($event)" class="form-control selectcolor" id="m_select2_1"
						name="param" [(ngModel)]="modelObj.tcId">
						<option value="" disabled selected>Select</option>
						<option *ngFor="let tcId of tcIdsDropDownData" [ngValue]="tcId.ids">
							{{ tcId.ids }}
						</option>
					</select>
				</div>
				<div class="col-md-2">
					<label>
						<b>Batch Id
							<span style="color: red; font-weight: bold">*</span></b>
					</label>
					<select (change)="batchIdChanged()" class="form-control selectcolor" id="m_select2_1" name="param"
						[(ngModel)]="modelObj.batchId">
						<option value="" disabled selected>Select</option>
						<option *ngFor="let batchId of batchIdDropDown" [ngValue]="batchId.ids">
							{{ batchId.ids }}
						</option>
					</select>
				</div>
				<div class="col-md-2">
					<label>
						<b>Batch Type
							<span style="color: red; font-weight: bold">*</span>
						</b>
					</label>
					<select (change)="getCandidateDropDown()" class="form-control selectcolor" id="m_select2_1"
						name="param" [(ngModel)]="modelObj.batchType">
						<option value="" disabled selected>Select</option>
						<option *ngFor="let type of batchTypeDropDown" [ngValue]="type">
							{{ type }}
						</option>
					</select>
				</div>

				<div class="col-md-2">
					<label>
						<b>Candidate Id</b>
					</label>
					<select class="form-control selectcolor" id="m_select2_1" name="param" [(ngModel)]="modelObj.canId">
						<option value="" disabled selected>All</option>
						<option *ngFor="let canId of candidateIdDropDown" [ngValue]="canId.ids">
							{{ canId.ids }}
						</option>
					</select>
				</div>
				<div class="col-md-6">
					<label> <br /> </label>
					<div *ngIf="currentUser?.role === 'Training Centre'">
						<button [disabled]="!modelObj.batchId" class="btn btn-primary" (click)="applyFilter()">
							Search</button>
						<button class="btn btn-secondary m-btn reset-btn" (click)="reset()">
							Reset
						</button>
					</div>
					<div *ngIf="currentUser?.role === 'Training Partner'">
						<button [disabled]="!valid" class="btn btn-primary" (click)="applyFilter()">
							Search</button>
						<button class="btn btn-secondary m-btn reset-btn" (click)="reset()">
							Reset</button>
					</div>
				</div>
			</div>
			<div>
				<div>
					<div class="form-group m-form__group row">
						<table class="notranslate table table-striped m-table">
							<thead class="table-head-style">
								<tr>
									<th style="width: 10%">Sr. No.</th>
									<th>Candidate ID</th>
									<th>Candidate Name</th>
									<th>Batch Name</th>
									<th>Action</th>
								</tr>
							</thead>
							<tbody>
								<tr *ngFor=" let candidate of candidateData; let i = index ">
									<td>{{ i + 1 }}</td>
									<td>
										{{ getCandidateUserName(candidate) }}
									</td>
									<td>{{ getCandidateName(candidate) }}</td>
									<td> {{ candidate.batchName ? candidate.batchName : "N/A" }} </td>
									<td>
										<div class="dropdown">
											<a href="#"
												class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill"
												data-toggle="dropdown">
												<i class="la la-ellipsis-h"></i>
											</a>
											<div class="dropdown-menu dropdown-menu-right">
												<a class="dropdown-item" (click)="updateProfilePhoto(candidate.candidateUserName)">
													Update Profile Photo
												</a>
												<a *ngIf="batchData && batchData.trackBatch && batchData.trackBatch === 'BATCH_ASSMT_RESULT_SSC_ACCEPTED'" class="dropdown-item" (click)="reGenerateCertificate(candidate.candidateUserName)">
													Re-Generate Certificate
												</a>
											</div>
										</div>
									</td>
								</tr>
								<tr *ngIf="candidateData.length === 0" style="color: grey; font-size: 17px">
									<td colspan="8">
										<p style="text-align: center">
											No Data Found
										</p>
									</td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
				<div *ngIf="length > 9">
					<app-pagination [count]="length" [defaultRecordsPerPage]="itemsPerPage"
						(pageNumber)="assignPageNo($event)" (recordsPerPage)="assignRecordsPerPage($event)">
					</app-pagination>
				</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="isChangeProfile && updateProfilePhotoForm" class="modal fade" id="profilePhoto" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
	aria-hidden="true" style="display: none;">
	<div class="modal-dialog modal-lg" role="document">
		<div class="modal-content">
			<div class="modal-header">
				<h5 class="modal-title" id="exampleModalLabel">
					Upload Profile Photo
				</h5>
			</div>
			<div class="modal-body">
				<form>
					<div class="form-group">
						<label for="recipient-name" class="form-control-label">
							Choose Profile Photo:
						</label>
					</div>
					<div >
						<div class="row">
							<div class="uploadProfileWidth col-lg-6" class="form-group" [formGroup]="updateProfilePhotoForm">
								<div class="col-12">
									<app-upload-file [formValue]="updateProfilePhotoForm.get('profilePicture')"
										 info="only jpg, png, jpeg" (valueChange)="fileUploaded($event)"
										></app-upload-file>
									<input type="hidden" formControlName="profilePicture" #fileInput>
									<app-form-control-messages [control]="updateProfilePhotoForm.get('profilePicture')"
										[name]="'Profile Picture'"></app-form-control-messages>
								</div>
							</div>
							<div class="col-6" *ngIf="isCrntProfilePicUpload">
								<div class="col-12 col-xl-2 col-sm-12 col-md-2">
									<img  [src]="profileImage" alt="Avatar"
									style="max-width:350px">
								</div>
							</div>
						</div>
					</div>
				</form>
			</div>
			<div class="modal-footer">
				<button type="button" #closeModal class="btn btn-secondary" (click)="closeCanProfilePhotoModel()">
					Close
				</button>
				<button type="button" class="btn btn-next" (click)="submitProfilePhoto()"
					[disabled]="!updateProfilePhotoForm.valid">
					Submit
				</button>
			</div>
		</div>
	</div>
</div>